/**
 * Created by quikr on 7/13/16.
 */

//List of constants for action types.. to avoid TYPOS in reducer and action creator
export const LOAD_COURSES_SUCCESS = 'LOAD_COURSES_SUCCESS';
export const STORE_LOGIN_SUCCESS = 'STORE_LOGIN_SUCCESS';
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const END_AJAX_CALL = 'END_AJAX_CALL';
export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const NO_ERROR = 'NO_ERROR';



/** WEBPACK FOOTER **
 ** ./src/redux/actions/actionTypes.js
 **/